import React, { useEffect, useState } from "react";
import { fetchServiceRequestStats } from "../../WindowDoor/ServiceRequests/api";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Mirrors the Service Request Manager's rail: open work, the unassigned
// slice of it, and parts on order.
const ServiceRequestManagerWidget = () => {
  const [stats, setStats] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    fetchServiceRequestStats()
      .then(setStats)
      .catch(() => setFailed(true));
  }, []);

  if (failed) {
    return (
      <WidgetFrame title="Service Requests" to="/windowdoor/service-requests">
        <WidgetEmpty>Couldn't load the queue.</WidgetEmpty>
      </WidgetFrame>
    );
  }

  if (!stats) {
    return (
      <WidgetFrame title="Service Requests" to="/windowdoor/service-requests">
        <WidgetEmpty>Loading the queue…</WidgetEmpty>
      </WidgetFrame>
    );
  }

  return (
    <WidgetFrame title="Service Requests" to="/windowdoor/service-requests">
      <div className="grid grid-cols-3 gap-2">
        <WidgetStat value={stats.unassigned ?? 0} label="Unassigned" />
        <WidgetStat value={stats.open ?? 0} label="Open" />
        <WidgetStat
          value={stats.byStatus?.["Parts Ordered"] ?? 0}
          label="Parts ordered"
        />
      </div>
    </WidgetFrame>
  );
};

export default ServiceRequestManagerWidget;
